import React, { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

/**
 * USEKO official logo. Reads settings.header_logo from the API and falls back
 * to the bundled default. Uses fileUrl() so it survives domain migrations.
 */
export default function UsekoLogo({ className = "h-11 w-auto", alt = "USEKO" }) {
  const [src, setSrc] = useState("/useko-logo-gold.png?v=4");
  useEffect(() => {
    api.get(`/settings?_=${Date.now()}`).then(r => {
      const custom = r.data?.header_logo;
      if (custom) setSrc(fileUrl(custom));
    }).catch(() => {});
  }, []);
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      data-testid="useko-logo"
    />
  );
}
